// extracted by mini-css-extract-plugin
module.exports = {"lds-heart":"HeartLoader_lds-heart__Cpze4"};